import { ModelBase } from 'store/model-base';

export class CmsBucketSwitch extends ModelBase {
    public static storeName: string = 'cmsBucketSwitch';

    public bucketSwitchSlider: CmsBucketSwitchCarousal;
    public bucketSwitchReview: CmsPlanSwitchReviewData;
    public requestSwitch: CmsPlanSwitchData;
    public switchPending: CmsPlanSwitchData;
    public success: CmsPlanSwitchData;
    public failure: CmsPlanSwitchData;
    public inactiveLine: CmsPlanSwitchData;
    public envelopeIcon: CmsMediaImage;
    public checkIcon: CmsMediaImage;
    public failureIcon: CmsMediaImage;
}
